<template>
  <div
    class="float"
    :class="sideContent? 'sideContent' : ''"
  >
    <swiper
      autoplay
      class="mySwiper"
    >
      <swiper-slide>
        <a
          :href="store.state.articlesData.payUrl2EN"
          target="_blank"
          v-if="XhLang == 'en'"
        >
          <div class="swiperImg">
            <img
              src="../../../assets/images/en/float-pay.png"
              :class="'market_pay_teaching'"
            />
          </div>
        </a>

        <a
          :href="store.state.articlesData.payUrl2CN"
          target="_blank"
          v-if="XhLang == 'cn'"
        >
          <div class="swiperImg">
            <img
              src="../../../assets/images/cn/float-pay.png"
              :class="'market_pay_teaching'"
            />
          </div>
        </a>

        <a
          :href="store.state.articlesData.payUrl2TH"
          target="_blank"
          v-if="XhLang == 'th'"
        >
          <div class="swiperImg">
            <img
              src="../../../assets/images/th/float-pay.png"
              :class="'market_pay_teaching'"
            />
          </div>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script setup>
import { useI18n } from "vue-i18n";
import { defineProps, ref } from "vue";
import { useStore } from "vuex";
const store = useStore();

const { locale } = useI18n();
const XhLang = locale.value;

const props = defineProps(["scroll"]);
const sideContent = ref(false);

const scrollToTop = () => {
  if (props.scroll > 10) {
    sideContent.value = true;
  } else {
    sideContent.value = false;
  }
};
window.addEventListener("scroll", scrollToTop);
</script>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {};
  },
};
</script>

<style lang=scss scoped>
.float {
  background: #3c2d37 url("../../../assets/images/float-bg.png") no-repeat
    center;
  background-size: 100% auto;
  position: relative;
  height: 2.7rem;
  width: 7.5rem;
  &.sideContent {
    position: fixed;
    bottom: 0;
    z-index: 999;
    left: 50%;
    margin-left: -3.75rem;
    background: none;
    height: 2.19rem;
  }
  .swiper,
  a {
    width: 100%;
    height: 100%;
    display: block;
    img {
      width: 100%;
    }
  }
  .swiperImg {
    height: 100%;
    img {
      height: 2.19rem;
    }
  }
  .swiperImg {
    position: relative;
    // display: flex;
    // align-items: center;
    .bnt {
      position: absolute;
      right: 0.1rem;
      z-index: 999;
      width: 2rem;
      height: 0.7rem;
      top: 0.5rem;
    }
  }
}
</style>